import { createRouter, createWebHashHistory } from "vue-router";
import ArchiveView from "./views/ArchiveView.vue";

// Hash history — LIFF apps are opened inside LINE's in-app browser via a
// single fixed LIFF URL; hash routing avoids needing server-side rewrite
// rules for deep links on whatever static host serves the build.
export const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: "/", name: "archive", component: ArchiveView },
    // Lazy-loaded: most sessions never visit these tabs, so each ships as
    // its own chunk instead of bloating the initial bundle every user pays for.
    { path: "/trash", name: "trash", component: () => import("./views/TrashView.vue") },
    { path: "/plans", name: "plans", component: () => import("./views/PlansView.vue") },
    // Notice-and-takedown gets its own screen rather than a panel inside the
    // item detail: writing the reason is the whole task, and `focus` chrome
    // (below) clears the quota header and bottom nav out of its way.
    {
      path: "/report/:itemId",
      name: "report",
      component: () => import("./views/ReportView.vue"),
      meta: { chrome: "focus" },
    },
    { path: "/settings", name: "settings", component: () => import("./views/SettingsView.vue") },
    { path: "/settings/groups", name: "groups", component: () => import("./views/GroupManagementView.vue") },
    {
      path: "/settings/delete-account",
      name: "delete-account",
      component: () => import("./views/AccountDeletionView.vue"),
    },
    // Anything unrecognised falls back to the archive. This is not defensive
    // padding: LIFF rewrites the URL on its way in (the `liff.state` first hop,
    // plus whatever the login round-trip leaves behind), so the hash the router
    // finally sees inside the LINE client is not always the one we handed out.
    // Without this the app renders its full chrome around an empty
    // <router-view> — no view, and no bottom tab matching route.path either,
    // which reads as "the app loaded but lost my files" rather than as an error.
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});
